export default "__VITE_ASSET__D0209uxS__"